import { UserPreferences } from 'features/user-preferences/types/user-preferences.types';

export const userPreferencesFeatureKey = 'userPreferences';

export const TABLE_NAME = {
  COMPLIANCE_PRIMARY_VERIFICATION: 'compliance-primary-verification',
  COMPLIANCE_SECONDARY_VERIFICATION: 'compliance-secondary-verification',
  COMPLIANCE_TODO: 'compliance-todo',
  CERTEMY_PRIMARY_VERIFICATION: 'certemy-primary-verification',
  CERTEMY_SECONDARY_VERIFICATION: 'certemy-secondary-verification',
  CERTEMY_TODO: 'certemy-todo',
};

export const DEFAULT_USER_PREFERENCES_STATE: UserPreferences = {
  tables: {},
  customFields: {},
  dashboard: {},
  reports: {},
};
